import React, { useMemo } from 'react';
import { CellContext, ColumnDef } from '@tanstack/react-table';
import { Switch } from '@/components/ui/switch';
import { useUserNotificationMethods } from '@/components/pages/SettingsPage/MainContent/UserManagement/NotificationMethods/useUserNotificationMethods';
import { updateTableCellData } from '@/components/pages/SettingsPage/MainContent/NotificationPreferences';
import { flattenDeliveryMethods } from '@/components/pages/SettingsPage/MainContent/UserManagement/NotificationMethods/utils';

const getTableCell = ({ getValue, row, column, table }: CellContext<any, unknown>) => {
  const value = getValue() as boolean;
  const handleToggle = (value: boolean) => {
    updateTableCellData({
      rowIndex: row.index,
      columnId: column.id,
      value,
      table,
    });
  };

  return <Switch checked={value} onCheckedChange={handleToggle} />;
};

export const useNotificationMethodsTable = () => {
  const { notificationMethods, isLoadingNotificationMethods, updateNotificationDeliveryMethods } =
    useUserNotificationMethods();
  const processedData = useMemo(() => notificationMethods.map(flattenDeliveryMethods), [notificationMethods]);

  const columns: ColumnDef<any>[] = useMemo(() => {
    return [
      {
        accessorKey: 'event_ui_name',
        header: 'Notification Type',
        cell: (info) => info.getValue(),
        enableFiltering: false,
        size: 200,
      },
      {
        accessorKey: 'email',
        header: 'Email',
        cell: getTableCell,
        enableFiltering: false,
        size: 50,
      },
      {
        accessorKey: 'sms',
        header: 'SMS',
        cell: getTableCell,
        enableFiltering: false,
        size: 50,
      },
      {
        accessorKey: 'dashboard',
        header: 'In-App',
        cell: getTableCell,
        enableFiltering: false,
        size: 50,
      },
    ];
  }, []);

  return {
    columns,
    data: processedData,
    isLoading: isLoadingNotificationMethods,
    updateNotificationDeliveryMethods,
  };
};
